window.addEventListener('DOMContentLoaded', () => {
  const itemSelector = '.mhecomm-hepdpbackwardscompatibility';
  const element = document.querySelector(itemSelector);
  if (element) {
    const url = element.dataset.url;
    const showSearch = element.dataset.showSearch === 'true';
    const isAuthor = element.dataset.isAuthor === 'true';
    const isDisabled = element.dataset.disableRedirect === 'true';
    const timeoutTime = Number(element.dataset.redirectTime);
    if (!showSearch && !isAuthor && !isDisabled) {
      setTimeout(() => {
        window.location.href = url;
      }, timeoutTime);
    }
  }
});
